import { Stack } from '@mui/material';
import { BaseHeader } from 'src/layouts/baseHeader';
import { HeaderControllerBar } from '../components/headerControllerBar';
import { MainDashboard } from '../components/mainDashboard/MainDashboard';
import { CustomDashboardProvider } from 'src/contexts/customDashboardContext/customDashboard.context';

export const CreateCustomDashboard = () => (
  <CustomDashboardProvider>
    <Stack sx={{ paddingBottom: '1rem' }}>
      <BaseHeader />
      <HeaderControllerBar sx={{ margintTop: '18px' }} />
      <MainDashboard sx={{ marginTop: '21px' }} mode="edit" />
    </Stack>
  </CustomDashboardProvider>
);
